import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../../';

import BackBtn from '../../back-button';

const SupportMenu = ({ data, parent }) => (
	<List
		bullets='none'
		className='absolute -right-full top-0 z-[11] h-[calc(100vh-59px)] w-full bg-white motion-safe:transition-all motion-safe:duration-500 sm:h-[calc(100vh-61px)] md:-right-80 md:w-80'
	>
		<BackBtn title={parent} />

		{data?.subnav?.[0] &&
			data.subnav.map((nav, index) => (
				<li
					key={index}
					className='p-5'
				>
					{nav.ctas?.[0] && (
						<List
							bullets='none'
							className='space-y-3'
						>
							{nav.ctas.map((cta, index) => (
								<li key={index}>
									<CTA
										data={cta}
										className='text-base font-semibold no-underline'
									/>
								</li>
							))}
						</List>
					)}
				</li>
			))}
	</List>
);

SupportMenu.propTypes = {
	data: PropTypes.object,
	parent: PropTypes.string,
};

export default SupportMenu;
